import React from "react";
import { MapStyleProperties } from "../../../utils/mapbox/mapStyleProperties";
import { connect } from "react-redux";
import { mapsSelectors, mapsActions } from "../../../state/ui/shared/maps";

const mapStateToProps = (state) => {
  return  {
    mapStyleUrl: mapsSelectors.getMapStyleUrl(state),
  }
}

const mapDispatchToProps = {
  toggleMapStyle: mapsActions.toggleMapStyle
}

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type Props = StateProps & DispatchProps;

class MapStyleButton extends React.PureComponent<Props, {}>{
  /**
   * Toggle map style and update state.
   */
  toggleMapStyle = (event) => {
    this.props.toggleMapStyle();
  }

  render() {
    const mapStyleIsStreet = this.props.mapStyleUrl === MapStyleProperties.StyleUrl.Streets;

    return (
      <div
        onClick={this.toggleMapStyle}
        className={`component--map-style-button ${mapStyleIsStreet ? "satellite" : "streets"}-map-button`}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MapStyleButton)
